import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { updateComponent } from '../../state/actions/componentsActions'
import { connect } from 'react-redux'

import { css, withStyles } from '../../styles/withStyles'
import Styles from './styles'

class Radio extends Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    const { component, dispatch } = this.props
    let value = 'selected'
    if (
      component.value === 'selected' ||
      component.status.indexOf('selected') > -1
    ) {
      this.input.checked = true
      value = 'selected'
    } else {
      this.input.checked = false
      value = ''
    }
    dispatch(
      updateComponent(
        component.id,
        { value, status: component.status.filter(s => s !== 'selected') },
        { bypassValidation: component.status.indexOf('error') < 0 }
      )
    )
  }

  componentWillReceiveProps(nextProps) {
    const { component, dispatch } = this.props
    if (
      nextProps.component &&
      nextProps.component.status.indexOf('selected') > -1 &&
      nextProps.component.value === '' &&
      component.value === 'selected'
    ) {
      dispatch(updateComponent(component.id, { value: 'selected' }))
    }
  }

  onClick() {
    const { component, widget, components, dispatch } = this.props
    if (!this.input.disabled && this.input.checked) {
      dispatch(updateComponent(component.id, { value: 'selected' }))
      let radioGroup = null
      if (widget.radioGroup) {
        const parentId = widget.radioGroup[component.id_]
        radioGroup = Object.keys(widget.radioGroup).filter(
          k => widget.radioGroup[k] === parentId
        )
      }
      const relatedRadioKeys = Object.keys(components).filter(
        k =>
          k !== component.id &&
          components[k].type === 'radio' &&
          (radioGroup
            ? radioGroup.some(id_ => id_ === components[k].id_)
            : k.startsWith(`${widget.name}-`))
      )
      relatedRadioKeys.forEach(k => {
        dispatch(updateComponent(k, { value: '' }, { bypassValidation: true }))
      })
    }
  }

  onImageClick(e) {
    if (Object.keys(this.imageModifiers).some(k => !!this.imageModifiers[k])) {
      const radio = Array.prototype.slice
        .call(e.target.childNodes)
        .find(n => n.type === 'radio')
      if (!!radio) {
        radio.click()
      }
    }
  }

  /**
   * Checks if none of the related radios are selected
   *
   * @return {Boolean}             The result
   */
  hasAnyRelatedRadioError() {
    const { components, widget, component } = this.props
    let radioGroup = null
    if (widget && widget.radioGroup) {
      const parentId = widget.radioGroup[component.id_]
      radioGroup = Object.keys(widget.radioGroup).filter(
        k => widget.radioGroup[k] === parentId
      )
    }
    let keys = Object.keys(components).filter(
      k => components[k].type === 'radio'
    )
    if (widget && radioGroup) {
      keys = keys.filter(k => radioGroup.some(id_ => id_ === components[k].id_))
    } else {
      keys = keys.filter(k => k.indexOf(component.id.split('-')[0]) > -1)
    }

    /*const keys = Object.keys(components).filter(
      k =>
        k.indexOf(component.id.split('-')[0]) > -1 &&
        components[k].type === 'radio'
    ) */

    const noneHasError = keys.reduce((res, k) => {
      return res && components[k].status.indexOf('error') < 0
    }, true)

    return !noneHasError
  }

  render() {
    const { widgets, component } = this.props
    const widget = widgets[component.id.split('-')[0]]

    this.imageModifiers = [
      component.id.indexOf('CARTA_FISICA') > -1 &&
        !component.value &&
        this.props.styles['radio--phisical-card'],
      component.id.indexOf('CARTA_FISICA') > -1 &&
        !!component.value &&
        this.props.styles['radio--phisical-card-selected'],
      component.id.indexOf('CARTA_VIRTUALE') > -1 &&
        !component.value &&
        this.props.styles['radio--virtual-card'],
      component.id.indexOf('CARTA_VIRTUALE') > -1 &&
        !!component.value &&
        this.props.styles['radio--virtual-card-selected'],
      component.id.indexOf('BONIFICO') > -1 &&
        !component.value &&
        this.props.styles['radio--bonifico'],
      component.id.indexOf('BONIFICO') > -1 &&
        !!component.value &&
        this.props.styles['radio--bonifico-selected']
    ].filter(e => !!e)

    if (!widget) return null

    return (
      <div
        {...css(
          this.props.styles.component,
          this.props.styles.radio,
          this.imageModifiers.length > 0 && this.props.styles['radio--image'],
          ...this.imageModifiers,
          component.id.indexOf('RIF_SPEDIZIONE_CARTA-') > -1 &&
            this.props.styles['component--third'],
          component.status.indexOf('readonly') > -1 &&
            component.status.indexOf('reallyreadonly') > -1 &&
            this.props.styles['radio--readonly'],
            (component.id === 'SEDE_AMMINISTRATIVA-ALTRO' || component.id === 'SEDE_AMMINISTRATIVA-SEDE_LEGALE') ?
              this.props.styles['radio--input-height'] : ''
        )}
        onClick={this.onImageClick.bind(this)}
      >
        <input
          ref={input => {
            this.input = input
          }}
          type="radio"
          name={
            widget.radioGroup ? widget.radioGroup[component.id_] : widget.group
          }
          disabled={component.status.indexOf('readonly') > -1}
          id={component.id}
          {...css(
            this.props.styles.input,
            this.imageModifiers.length > 0 && this.props.styles['input--image']
          )}
          value={component.value}
          onClick={this.onClick.bind(this)}
        />
        <label
          htmlFor={component.id}
          {...css(
            this.props.styles.label,
            this.imageModifiers.length > 0 && this.props.styles['label--image'],
            this.hasAnyRelatedRadioError() &&
              this.props.styles['label--invalid']
          )}
        >
          {component.cleanName}
          {!!component.description ? (
            <div
              {...css(
                this.props.styles.sublabel,
                component.status.indexOf('readonly') > -1 &&
                  component.status.indexOf('reallyreadonly') > -1 &&
                  this.props.styles['sublabel--readonly']
              )}
            >
              {component.description}
            </div>
          ) : (
            ''
          )}
        </label>
      </div>
    )
  }
}

Radio.propTypes = {
  widget: PropTypes.object.isRequired,
  component: PropTypes.object.isRequired,
  styles: PropTypes.object.isRequired
}

const mapStateToProps = (state, ownProps) => {
  const { components, widgets } = state
  return { component: components[ownProps.component.id], widgets, components }
}

export default connect(mapStateToProps)(withStyles(Styles)(Radio))



// WEBPACK FOOTER //
// ./components/radio/index.js